export const CONTENTREPOSITORY_CONSTANTS = {
    DEFAULT_TAKE: 10,
    DEFAULT_SKIP: 0,
    DEFAULT_PAGE: 1
};
